import { UserRole, UserRoles } from '@/models/User';

export enum AudienceGroups {
  VIRGIN_COMPANIES = 'VIRGIN_COMPANIES',
}

export type AudienceGroup = keyof typeof AudienceGroups

export type BlogAudience = UserRole | AudienceGroup

export const audienceOptions = () => {
  const userRoles = Object.keys(UserRoles).sort() as BlogAudience[];
  const audienceGroups = Object.keys(AudienceGroups).sort() as BlogAudience[];
  return [...userRoles, ...audienceGroups];
};
